'use strict';

var _ = require('lodash');
var SystemConfigButtonsUtilsService = function SystemConfigButtonsUtilsService() {
  function hasLocalData(gridPanel) {
    return !_.isUndefined(gridPanel.localData) && !_.isFunction(gridPanel.localData);
  }
  function addRow(row, columns, data, customAddNew) {
    if (_.isFunction(customAddNew)) {
      row = customAddNew(row);
    }
    data.unshift(setStructureWithOldValues(row, columns));
  }
  function addRowToGrid(row, gridPanel, customAddNew) {
    var columns = gridPanel.jqxGridSettings.columns;
    if (hasLocalData(gridPanel)) {
      addRow(row, columns, gridPanel.localData, customAddNew);
    } else {
      addRow(row, columns, gridPanel.jqxGridSettings.source.loadedData, customAddNew);
    }
  }
  function reloadGrid(gridPanel) {
    var data = hasLocalData(gridPanel) ? gridPanel.localData : gridPanel.jqxGridSettings.source.loadedData;
    gridPanel.updateData(data);
  }
  function setStructureWithOldValues(row, columns) {
    _.forEach(columns, function (col) {
      _.set(row, '_old.' + col.datafield, undefined);
    });
    return row;
  }
  function refreshGrid(gridPanel) {
    gridPanel.clearCache();
    gridPanel.jqxGridSettings.jqxGrid('updatebounddata', 'data');
  }
  return {
    addRowToGrid: addRowToGrid,
    reloadGrid: reloadGrid,
    hasLocalData: hasLocalData,
    refreshGrid: refreshGrid
  };
};
SystemConfigButtonsUtilsService.$inject = [];
module.exports = SystemConfigButtonsUtilsService;